module.exports = __webpack_public_path__ + "img/DealerIcons-Facebook-Off.00fec74.jpg";